import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'forbidden',
    templateUrl: 'forbidden.component.html'
})

export class ForbiddenComponent implements OnInit {

    public message: string;
    public values: any[];

    constructor() {
        this.message = 'ForbiddenComponent constructor';
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./angularApp/app/forbidden/forbidden.component.ts